export default __webpack_public_path__ + "static/media/noData.eb52d74f.png";